<template>
    <v-card>
            <v-card-text style="font-size:16px; color:#333333;" primary-title class="justify-center">
              <div style="padding-top:20px;"><p style="text-align: center;" v-text="message"></p></div>
            </v-card-text>
            <v-card-actions class="justify-center" id="action" style="margin-top:0px;">
                <v-btn depressed v-if="showYesNo" style="width: 128px;height: 35px;" color="#E561A9" class="mx-2 px-10" dark v-on:click="$emit('no-button-tapped')"><b>{{ $t("common_cancel") }}</b></v-btn>
                <v-btn depressed style="width: 128px;height: 35px;" color="#5E81ED" class="mx-2 px-10" dark v-on:click="$emit('ok-button-tapped',false)"><b>{{ $t("web_yes") }}</b></v-btn>
            </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: {
    message: String,
    showYesNo: Boolean
  }
};
</script>

<style scoped>
#action {
  padding-bottom: 20px !important;
}

.v-btn {
  border-radius: 2px;
}
</style>

